import { render, staticRenderFns } from "./AddBadgeModal.vue?vue&type=template&id=8414a46c&scoped=true&"
import script from "./AddBadgeModal.vue?vue&type=script&lang=js&"
export * from "./AddBadgeModal.vue?vue&type=script&lang=js&"
import style0 from "./AddBadgeModal.vue?vue&type=style&index=0&id=8414a46c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8414a46c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDialog,VTextField})
